// extracted by mini-css-extract-plugin
module.exports = {"container":"_2weaydf4r_keVDQXWX7tDw","squares":"PRHYlEPvOThwGHh13Z5Y8","countCard":"_3UJqBElMg45ttIxcAPGAyB","paragraph":"_1VKB4BwD-FEn7Y0org_Dc0"};